var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',_vm._b({ref:"autocomplete",attrs:{"clearable":"","items":_vm.options,"item-text":"text","item-value":"value","solo":_vm.solo},on:{"blur":_vm.emitBlur},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-autocomplete',_vm.resetProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }